// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiInsurance {
    static getAttributeTypeMap() {
        return PharmacyBiInsurance.attributeTypeMap;
    }
}
PharmacyBiInsurance.discriminator = undefined;
PharmacyBiInsurance.additionalProperties = false;
PharmacyBiInsurance.attributeTypeMap = [
    {
        "name": "priority",
        "baseName": "priority",
        "type": "string"
    },
    {
        "name": "type",
        "baseName": "type",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiInsurance.js.map